/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'displayNullValue'
})
export class DisplayNullValuePipe implements PipeTransform {

  transform(value: any, nullValue = '-'): any {
    if(value){
      return value;
    }else{
      return nullValue;
    }
  }

}
